export var ReactionType;
(function (ReactionType) {
    ReactionType["allergy"] = "Allergy";
    ReactionType["adverseReaction"] = "Adverse Reaction";
})(ReactionType || (ReactionType = {}));
export var PrescriptionStatuses;
(function (PrescriptionStatuses) {
    PrescriptionStatuses["erxSent"] = "eRx Sent";
    PrescriptionStatuses["faxSent"] = "Fax Sent";
    PrescriptionStatuses["pharmacyVerified"] = "Pharmacy Verified";
    PrescriptionStatuses["error"] = "Error";
    PrescriptionStatuses["epcsError"] = "Epcs Error";
    PrescriptionStatuses["printed"] = "Printed";
})(PrescriptionStatuses || (PrescriptionStatuses = {}));
